// This is a sample keystore. DO NOT USE THIS. Your idp should have it's own secret file.

export const keystore = {
  keys: [
    {
      alg: "RS256",
      kty: "RSA",
      kid: "xeOjes9u3AcU4LBzcanEM7pZLwSlxaN7U62ZzOBDQuw",
      e: "AQAB",
      n:
        "oB2LgkiZZ5iLAz1d4ua7sVxdbzY2nIRkDtf4UE08mWsD6UYRzLR98_gMAfnKB8i9yPCQkxfA5w_SZq6Y7odG1qSwLHM2mb_O2GSvY9kaG00UpeeEJCR19c7Jkcmq3GXh4yujnm2TFQ6YAzYNgrXkHlusaFUApJaQN6zr4AvmR_vX_5i__Ku7nuU-GbaV75LSr8o0QANdYFF0ooz5DJvydPplF8mO9_oD7ceSNLWP1AXlFs5JH6MEhH02dELb4-zeLcVzhoqON60cABTpbYSf1lLbYZsVUQ3cYE9CxXaByY2YNuQgc0k29mSmUvwEs0hNA5xUcE3-y_qKpYKniErb9Q",
      d:
        "FmiMIcuvTIRY0DdCcIMCOaxHl0zrD7SnnDw1kGd-16nWfktEKnYIOqC4bX5b_ALoLLseQLfOU4gvVheRZ7CfBWM_FLl7JsFlXXuZ4Et-D9wVy7I_GB_SMniiVTj4JKhNmNF-sKl9MDE-rRRfh6-VIXqLAn8C_AXmYSReTpjbva8T-fq6vHgB9GmRqW4yRpFta3CA2uJpfnQBzIXNuBHFnk7C7e3omgplXHicuuT3GQnKZlhsREXN1BK7_WcK6OZERqnx-fOl42Sq2pNSSLaLu42vhmvvEXBbHUFkEOU4x0QmpdjhpynQS5yS30xJf9NI9DROTSncVbswjLiI_XPOgQ",
      p:
        "7mtMx8m9zSzhWezMirL0neazpIw2lBYJStmCkyoT0rKAw0TJ1rx-sLh_Skn6BbTSNoJWZsiMC9AzUaER3LDBQda_LTYAiEtr3q3TeWjs2O7Q_QCGP2CGCpWrYddWKumv6ye2ZdgORlXAuOqO2GavqZJgpo9b9mTfqRq2pPKADfk",
      q:
        "q-wVzVmX5dZI8O5JLEMaBRbZtQIx0EyyN9Zy8itWgcfvYdU1WY8-KSZg67ZvkOBSScLx8y3V0wcc5kXD6W5PFKqVfwhfKABHimB8QAKPZCb-RBWDbvciNTi1CPJVNkLBtiiI9MWO6VSytOtokskOvHcA4mwMrIfxD_0XGU4YLN0",
      dp:
        "B9Uck5-sDZaA3Lxrx86zPJC8rBYzINBMg9n7cSw7tHtKwZ975gMRQmr9O4qMnS1gjovfnMbP2v9_ABqDhLWF08zjQO_6OoAHziv1u5JX3ZSS5wziXCimnqhmFfPGD-jXb6lBU70yUts0Vp7WDIPrF24IoNAq3EBaHKsU_vw8erk",
      dq:
        "ICtZ3QXhtWEGXwbHbF_V85PWAte5SHfBdU9MTOItGrW1pkHF7M8v23VR92k4sQw4eZLfwRgXhZg0ISZ2xSwd4gkVViLT42FCAbOSLEwOVrgxJb48zLuzi-_jeBwYM8IECzjEf8CjwCdYFSBjfevfNQazhKqhKHt7cPlzpAmH3oU",
      qi:
        "E3W6OfqeAzVCvylUpavcaBQhBRMEvnargBUSD8LT0smIldDm0SuTZ2fzueTfynd-9tvb9Ny_Tr9uSS-yWDHulnPfQL7LOdI1TWAXEy4278FJZwGCElSvjJafK_KS36sTw614YOV0UitWCd21aMWkKlJboh3kzEZEehFNAz2Iq-M",
      key_ops: ["verify"],
    },
  ],
};
